<template>
  <div>
    <div class="tw-flex tw-justify-end tw-my-4">
      <vs-select
          label="Sayfada Gösterilecek Kayıt Sayısı"
          v-model="pageSize"
          @change="handlePageSizeChange"
      >
        <vs-select-item
            v-for="size in pageSizes"
            :key="size"
            :value="size"
            :text="size"
        />
      </vs-select>
    </div>

    <vs-table stripe :data="list">
      <template slot="header">
        <div class="tw-w-full tw-flex tw-items-center tw-justify-between">
          <h3>En Çok Uğranan {{ pageSize }} Sayfa</h3>
          <vs-button
              radius
              size="small"
              color="warning"
              type="border"
              icon="mdi-cached"
              @click="get();"
          >
          </vs-button>
        </div>
      </template>
      <template slot="thead">
       
        <vs-th>Sayfa</vs-th>
        <vs-th>Ziyaret Sayısı</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(item, i) in data" :key="i" >
          <vs-td>
            {{ i + 1 }}.
          </vs-td>
          <vs-td :data="item._id">
            <div>{{ 
              (item._id=="/appeals") ? "Etkinlik Kayıt" :
              (item._id=="/home") ? "Anasayfa" :
              (item._id=="/appeals/create") ? "Etkinlik Kayıt Oluşturma" :
              (item._id=="/informations") ? "Etkinlik Bilgileri" :
              (item._id=="/informations/create") ? "Etkinlik Bilgileri Ekleme" :
               (item._id=="/finishevent") ? "Etkinlik Bitir" :
                (item._id=="/ends") ? "Etkinlik Sonrası" :
                (item._id=="/surveys") ? "Etkinlik Anketleri" :
                 (item._id=="/FolderManagement") ? "Etkinlik Dosya Yönetimi" :
                  (item._id=="/MyActivities") ? "Etkinliklerim" :
               (item._id=="/prequest") ? "Dilek Şikayet" :
               (item._id=="/dashboard") ? "Rapor Ekranı" :
               (item._id=="/analytics") ? "Log Ekranı" :
               (item._id=="/users") ? "Kullanıcı Yetki Düzenleme" :
                 (item._id=="/users/create") ? "Kullanıcı Oluşturma" :
                 (item._id=="/login") ? "Login" : 
                 (item._id=="/institutions") ? "Kurum Onay Sayfası(admin)" : 
                 (item._id=="/rooms") ? "Salon Onay Sayfası(admin)" : 
                 (item._id=="/events") ? "Etkinlik Türü Onay Sayfası(admin)" : 
                 (item._id=="/etkinlikbitir") ? "Etkinlik Bitir" : 
                  (item._id=="/profile") ? "Profil Sayfası" : 


               item._id
                   
            
            
            
             }}</div>
          </vs-td>
          <vs-td :data="item.count">
            <div>{{ item.count }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <TopPagesBarChart
        v-if="loaded"
        :chart-data="chartData"
        :key="chartKey"
        class="tw-mt-4"
    />

  </div>
</template>

<script>
  import { analyticsMixin } from "@/libs/analytics/analyticsMixin";
  import TopPagesBarChart from './TopPagesBarChart'

  export default {
    name: "TopPages",
    title: "Sayfa Analizi",

    mixins: [
      analyticsMixin,
    ],

    components: {
      TopPagesBarChart,
    },

    data() {
      return {
        decoratorKey: 'top-pages',
        pageSizes: [2, 5, 10, 20, 30],
        loaded: false,
        chartKey: 1,
      }
    },

    watch: {
      info(val) {
        if(val) {
          this.drawChart()
        }
      }
    },

    methods: {
      drawChart() {
        let labels = _.map(this.info.data, it => { 
          let name =  (it._id=="/appeals") ? "Etkinlik Kayıt" :
              (it._id=="/home") ? "Anasayfa" :
              (it._id=="/appeals/create") ? "Etkinlik Kayıt Oluşturma" :
              (it._id=="/informations") ? "Etkinlik Bilgileri" :
              (it._id=="/informations/create") ? "Etkinlik Bilgileri Ekleme" :
               (it._id=="/finishevent") ? "Etkinlik Bitir" :
                (it._id=="/ends") ? "Etkinlik Sonrası" :
                 (it._id=="/surveys") ? "Etkinlik Anketleri" :
                 (it._id=="/FolderManagement") ? "Etkinlik Dosya Yönetimi" :
                 (it._id=="/MyActivities") ? "Etkinliklerim" :
               (it._id=="/prequest") ? "Dilek Şikayet" :
               (it._id=="/dashboard") ? "Rapor Ekranı" :
               (it._id=="/analytics") ? "Log Ekranı" :
               (it._id=="/users") ? "Kullanıcı Yetki Düzenleme" :
                 (it._id=="/users/create") ? "Kullanıcı Oluşturma" :
                 (it._id=="/login") ? "Login" : 
                 (it._id=="/institutions") ? "Kurum Onay Sayfası(admin)" : 
                 (it._id=="/rooms") ? "Salon Onay Sayfası(admin)" : 
                 (it._id=="/events") ? "Etkinlik Türü Onay Sayfası(admin)" : 
                 (it._id=="/etkinlikbitir") ? "Etkinlik Bitir" : 
                  (it._id=="/profile") ? "Profil Sayfası" : 


               it._id



          return name
        })

        let values = _.map(this.info.data, it => {
          return it.count;
        })

        this.chartData = {
          labels: labels,
          datasets: [
            {
              label: "Sayfa İstatistikleri",
              backgroundColor: "#00D8FF",
              data: values,
            }
          ],
        }

        this.loaded = true
        this.chartKey++
      }
    },
  }
</script>

<style scoped>

</style>